/**
 * 金融機関検索
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/zip_codes`

 const master_search_zip_code = {
   namespaced: true,
   state: {},
   getters: {},
   actions: {
     /**
      * 郵便番号の取得
      * @param commit
      * @param { Object } params
      * @return {Promise<unknown>}
      */
     show ({ commit }, { params }) {
       return new Promise((resolve) => {
         Vue.$http.get(API_PATH, { params: params }).then(data => {
           resolve(data.content)
         })
       })
     },
   },
   mutations: {},
 }
 export default master_search_zip_code
